import dayjs from 'dayjs';
import { ChampCompteRendu } from '../compte-rendu/champ-compte-rendu.model';
import { Coordinates } from '../coordinates.model';
import { UserEvent } from './user-event.model';

export class FinVacationInterventionEvent extends UserEvent {
  public static NAME = 'FIN_INTER_EVENT';

  constructor(
    public idVacation: string,
    public fin: dayjs.Dayjs,
    public signature?: string,
    public champsPersonnalises: ChampCompteRendu[] = [],
    coordinates?: Coordinates
  ) {
    super(FinVacationInterventionEvent.NAME, undefined, coordinates);
  }

  public static hydrate(obj: FinVacationInterventionEvent): FinVacationInterventionEvent {
    return new FinVacationInterventionEvent(obj.idVacation, dayjs(obj.fin), obj.signature, obj.champsPersonnalises, obj.coordinates);
  }
}
